// @ts-nocheck
import React, { createContext, memo, useContext, useEffect } from 'react';
import { ContextProvider, ComponentMap } from '../../utils';
import { NavigationContext, NavigationContextProvider } from '../../contexts';
import { OfferCardContextProvider } from '../../commonoffer';
export const NaturalDisasterContext = /*#__PURE__*/createContext(null);
const NaturalDisasterContainer = () => {
  const {
    screen,
    metadata,
    logUserEvent
  } = useContext(NavigationContext);

  // @ts-ignore
  const Component = ComponentMap[screen];
  useEffect(() => {
    logUserEvent({
      action: 'navigation',
      description: `user navigated to ${metadata.id} screen`,
      type: 'NaturalDisaster'
    });
  }, [logUserEvent, metadata.id]);
  return /*#__PURE__*/React.createElement(Component, metadata);
};
const NaturalDisaster = _ref => {
  let {
    ...props
  } = _ref;
  const {
    metadata,
    logApiEvent,
    logUserEvent,
    config,
    forbearanceApiParams,
    onComplete,
    requestedBy,
    accessToken
  } = props;
  return /*#__PURE__*/React.createElement(ContextProvider, null, /*#__PURE__*/React.createElement(OfferCardContextProvider, {
    requestedBy: requestedBy,
    logUserEvent: logUserEvent,
    logApiEvent: logApiEvent,
    cardType: "Natural Disaster",
    leadApiParams: {
      baseUrl: '',
      xApiKey: ''
    }
  }, /*#__PURE__*/React.createElement(NavigationContextProvider, {
    config: config,
    initialState: metadata.initialState,
    logUserEvent: logUserEvent,
    logApiEvent: logApiEvent,
    onComplete: onComplete,
    request: metadata.request,
    leadApiParams: forbearanceApiParams,
    accessToken: accessToken
  }, /*#__PURE__*/React.createElement(NaturalDisasterContainer, null))));
};
export default /*#__PURE__*/memo(NaturalDisaster);
//# sourceMappingURL=index.js.map